import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AuthInfo } from '../types';

export const useTrackLoggedIn = () => {
  const { track, identify } = useAnalyticsUtilities();

  const trackLoggedIn = useCallback(
    (params: AuthInfo) => {
      const { id, email, firstName, lastName } = params;

      identify(id, {
        email: email,
        first_name: firstName,
        last_name: lastName,
      });

      track(`Logged in`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [identify, track],
  );

  return { trackLoggedIn };
};
